import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import Clarity from '@microsoft/clarity'
import { APP_NAME } from 'app-config'

import {
  selectCurrentVariantCohort,
  selectIsGrowthbookReady,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID, selectUserCountryCode } from 'root-redux/selects/user'

import { CLARITY_PROJECT_IDS } from 'analytics-constants'

import { useCookieConsentAnswer } from './useCookieConsentAnswer'

const enum ClarityConsent {
  GRANTED = 'granted',
  DENIED = 'denied',
}

export const useClarityInitialization = () => {
  const uuid = useSelector(selectUUID)
  const language = useSelector(selectLanguage)
  const cohort = useSelector(selectCurrentVariantCohort)
  const userCountryCode = useSelector(selectUserCountryCode)
  const isGrowthbookReady = useSelector(selectIsGrowthbookReady)
  const { isEUUser, isUSUser, canUseAdvertising, canUseAnalytics } =
    useCookieConsentAnswer()
  const clarityProjectKey = CLARITY_PROJECT_IDS[APP_NAME]
  const isPotentiallyProtected = isEUUser || isUSUser
  const isConsentResolved =
    !!userCountryCode && (!isPotentiallyProtected || isGrowthbookReady)

  useEffect(() => {
    if (!clarityProjectKey) return

    Clarity.init(clarityProjectKey)
  }, [clarityProjectKey])

  useEffect(() => {
    if (!clarityProjectKey || !uuid || !language) {
      return
    }

    Clarity?.identify(uuid)
    Clarity?.setTag('locale', language)
    Clarity?.setTag('cohort', cohort)
  }, [clarityProjectKey, cohort, language, uuid])

  useEffect(() => {
    if (!clarityProjectKey || !isConsentResolved) return

    Clarity?.consentV2({
      ad_Storage: canUseAdvertising
        ? ClarityConsent.GRANTED
        : ClarityConsent.DENIED,
      analytics_Storage: canUseAnalytics
        ? ClarityConsent.GRANTED
        : ClarityConsent.DENIED,
    })
  }, [clarityProjectKey, isConsentResolved, canUseAdvertising, canUseAnalytics])
}
